import React, { useMemo, useState } from "react";
import TopbarWrapper from "../../components/FlowBoard/TopbarWrapper";
import { Button, Tooltip } from "antd";
import "./PinboardTopbar.css";
import { ROUTES } from "../../utilities/Constants/Constants";
import { useGenerateSemanticModelMutation } from "../../service/apiSlices/sematicModel";
import { useWorkbenchContext } from "../../context/WorkbenchContext";
import { useNavigate } from "react-router-dom";
import { showSuccessToast } from "../../utilities/toastUtils";
import ContinueGenerateModel from "../../components/ContinueGenerateModel/continueGenerate";

const PinboardTopbar = ({ queryResult }: { queryResult: any }) => {
  const [generateModelOpen, setGenerateModelOpen] = useState(false)
  const { workBenchData } = useWorkbenchContext();
  const [generateModel] = useGenerateSemanticModelMutation();
  const modelCompleted: any = sessionStorage.getItem("modelCompleted")

  const isThereAnyResult = useMemo(() => queryResult?.data?.length > 0, [queryResult?.data?.length])

  const navigate = useNavigate();

  const handleGenarateModel = () => {
    let payload = {
      connection_key: workBenchData.connection_key,
      mapping_link_id: workBenchData.mapping_link_id,
    };
    generateModel(payload)
      .unwrap()
      .then((res: any) => {
        if (res.status_code === 200) {
          showSuccessToast(res.message);
          navigate(ROUTES.QUERYLIST, { replace: true });
          sessionStorage.removeItem("SemanticData");
        }
      })
      .catch((err: any) => { });
  };

  return (
    <TopbarWrapper className="justify-content-end">
      <div className="actions-wrapper">
        <Tooltip title={isThereAnyResult ? '' : 'No results found for the saved configuration. The button will be enabled if any results are found for the saved.'}>
          <Button
            className="action-btn"
            onClick={() => setGenerateModelOpen(true)}
            disabled={!isThereAnyResult || modelCompleted === '100'}
          >
            Generate Model
          </Button>
        </Tooltip>
      </div>
      <ContinueGenerateModel
        visible={generateModelOpen}
        onOk={handleGenarateModel}
        onCancel={() => setGenerateModelOpen(false)}
      />
    </TopbarWrapper>
  );
};

export default PinboardTopbar;
